import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { SbbDateAdapter } from '@sbb-esta/angular/core';
import { SbbTableModule } from '@sbb-esta/angular/table';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ApiModule} from './client/js-openapi3-client-v3';
import {OpenapiConfig} from './client/openapi-config';
import {FlyingFocusModule} from './features';
import {VersionComponent} from './pages/version/version.component';
import {FzfDateAdapter} from './shared/datetime/fzf-date-adapter';

@NgModule({ declarations: [AppComponent, VersionComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FlyingFocusModule,
        AppRoutingModule,
        ApiModule.forRoot(() => OpenapiConfig),
        SbbTableModule], providers: [
        { provide: SbbDateAdapter, useClass: FzfDateAdapter },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
